
import { OnInit, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DEFAULT_LATITUDE, DEFAULT_LONGITUDE } from '@shared/constant/shared.constant';
import { ConfigService } from '@core/services/config.service';

declare const google: any;
@Component({
  selector: 'app-super-admin-current-map-location',
  templateUrl: './super-admin-current-map-location.component.html',
  styleUrls: ['./super-admin-current-map-location.component.scss']
})
export class SuperAdminCurrentMapLocationComponent implements OnInit {
  locAddress:any;
  @ViewChild('mapElement', { static: true }) mapElement: any;
  receivedData: any;
  geocoder?: any = null;
  title = 'AppComponent'
  map: any;
  marker: any = null;
  streetViewLink = '';
  count: number = 0;
  formattedLocation: any;
  userLocationData:any;
  searchLocationMarker: any;
  lat:number;
  lng:number;
  
  markerPosition: {
    lat: number
    lng: number
  } | undefined;

  clickedLocation: {
    lat:number,
    lng:number
  };
  parkingForm!: FormGroup;
  
  constructor(
    public readonly ref: DynamicDialogRef,
    private readonly fb: FormBuilder,
    private readonly configService: ConfigService,
    private readonly config: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.receivedData = this.config.data;
        this.openMap();
    this.parkingForm = this.fb.group({ 
      locAddress: ['', Validators.required],       
    });
  }

  openMap(): void {
        if (this.receivedData && this.receivedData.lat !== undefined && this.receivedData.lng !== undefined) {
      this.markerPosition = {
        lat: this.receivedData.lat,
        lng: this.receivedData.lng
      };
      this.handleMapClick( this.markerPosition.lat,this.markerPosition.lng);
    } else {
     this.markerPosition = {
        lat: DEFAULT_LATITUDE,
        lng: DEFAULT_LONGITUDE
      }; 
    }
  
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      center: this.markerPosition,
      zoom: 15,
    });
    this.searchLocationMarker = new google.maps.Marker({
      position: this.markerPosition,
      map: this.map,
      title: 'Your Location'
    });
  
    this.geocoder = new google.maps.Geocoder();
    google.maps.event.addListener(this.map, 'click', (event: any) => {
      this.handleMapClick(event.latLng.lat(), event.latLng.lng());
    });
  }

getCurrentLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.lat = userLocation.lat
        this.lng = userLocation.lng
        this.clickedLocation = {
          lat:userLocation.lat,
          lng:userLocation.lng
        }
        this.marker = new google.maps.Marker({
          position: this.clickedLocation,
          map: this.map,
          title: 'Your Location'
        });
        this.map.setCenter(this.clickedLocation);
      });
    }
  }
  selectLocation(): void {
    if (this.formattedLocation) {
      this.ref.close(this.formattedLocation);
    }
    else {
      this.ref.close(this.receivedData);

    }
  }
  cancel() {
    if (this.receivedData) {
      this.ref.close(this.receivedData);
    }
    else {
      this.ref.close();
    }
  }
  handleMapClick(lat, lng): void {
    this.searchLocationMarker?.setMap(null);
    this.marker?.setMap(null);
    this.clickedLocation = {
        lat: lat,
        lng: lng
    };
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: this.clickedLocation }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;
          this.formattedLocation = {
            lat: lat,
            lng: lng,
            address: address
          };

          this.streetViewLink = `${this.configService.get('mapUrls').streetView}${this.clickedLocation.lat},${this.clickedLocation.lng},16z?hl=en&q=${address}`;

          this.marker = new google.maps.Marker({
            position: this.formattedLocation,
            map: this.map,
            title: 'Your Location'
          });

          const infoWindowContent = `<div>${address}</div>`;
          const infowindow = new google.maps.InfoWindow({
            content: infoWindowContent
          });
          infowindow.open(this.map, this.marker);
        }
    });
}

  searchAutoCompleteLocation(_location: any) {
    const data=_location
    this.markerPosition = {
      lat: data.latitude,
      lng: data.longitude
    }
    this.handleMapClick(this.markerPosition.lat,this.markerPosition.lng);
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      center: { lat: data.latitude, lng: data.longitude },
      zoom: 15,
    })
    this.formattedLocation=this.markerPosition;
    this.searchLocationMarker = new google.maps.Marker({
      position: this.markerPosition,
      map: this.map,
      title: 'Your Location'
    })
    this.geocoder = new google.maps.Geocoder();
    google.maps.event.addListener(this.map, 'click', (event: any) => {
      this.handleMapClick(event.latLng.lat(),event.latLng.lng());
    });
  }
  }